/** Curated IANA zones for admin count-calendar configuration (mirrors server). */
export const BUSINESS_UNIT_COUNT_CALENDAR_TIMEZONE_OPTIONS = [
  { id: 'America/Denver', label: 'Mountain — Denver' },
  { id: 'America/Chicago', label: 'Central — Chicago' },
  { id: 'America/New_York', label: 'Eastern — New York' },
  { id: 'America/Los_Angeles', label: 'Pacific — Los Angeles' },
  { id: 'America/Phoenix', label: 'Arizona — Phoenix' },
  { id: 'America/Anchorage', label: 'Alaska — Anchorage' },
  { id: 'Pacific/Honolulu', label: 'Hawaii — Honolulu' },
  { id: 'UTC', label: 'UTC' },
] as const;

export const DEFAULT_COUNT_CALENDAR_TIMEZONE = 'America/Denver';

/** Format a BU calendar day (`YYYY-MM-DD`) for display in that zone. */
export function formatBuCalendarDayLabel(ymd: string, timeZone: string = DEFAULT_COUNT_CALENDAR_TIMEZONE): string {
  const parts = ymd.split('-').map((p) => parseInt(p, 10));
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) {
    return ymd;
  }
  const [y, m, d] = parts;
  const anchor = new Date(Date.UTC(y, m - 1, d, 12, 0, 0));
  try {
    return new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone,
    }).format(anchor);
  } catch {
    return ymd;
  }
}

/** Today’s calendar day in the given IANA zone (`YYYY-MM-DD`). */
export function buCalendarTodayYmd(timeZone: string = DEFAULT_COUNT_CALENDAR_TIMEZONE): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  let y = '';
  let m = '';
  let d = '';
  for (const p of parts) {
    if (p.type === 'year') y = p.value;
    if (p.type === 'month') m = p.value;
    if (p.type === 'day') d = p.value;
  }
  return `${y}-${m}-${d}`;
}
